/**
 * The App Container wraps the rest of the application.
 * Put any theming or global stuff in this file.
 */
import React from 'react';
import { Helmet } from 'react-helmet';

import Container from './components/Container';

const App = ({ children }) => (
	<Container>
		<Helmet titleTemplate="API Explorer - %s" defaultTitle="Home">
			<meta
				name="description"
				content="A simplified UI to validate the results of the Search, Recommendations, Suggestions and Taxonomy APIs so that we can prove the results before integration and release on brand websites."
			/>
		</Helmet>
		{children}
	</Container>
);

export default App;
